import React from "react";
import { CameraOptionsWrapper } from "../fieldvision.style";
import { ButtonShapes } from "@mlb/react-patterns/components/Button/button.types";
import ButtonGroup from "@mlb/react-patterns/components/ButtonGroup/buttonGroup";
import {
  PublicCameraConfig,
  PublicCameraOption,
  CAMERA_CONFIGS,
} from "../../FieldVisionController";

interface CameraOptionsProps {
  setIndex: React.Dispatch<React.SetStateAction<number>>;
  setCameraType: (camType: PublicCameraOption) => void;
  activeButtonIndex: number;
}

const buttonsConfig = CAMERA_CONFIGS.map((camera: PublicCameraConfig) => {
  return {
    type_: camera.type,
    label: camera.title,
    hasHover: true,
    shape: ButtonShapes.HOLLOW,
  };
});

const CameraOptions = (props: CameraOptionsProps) => {
  const { setCameraType, activeButtonIndex, setIndex } = props;

  const onClick = (e: {
    selected: number[];
    changes: { type_: PublicCameraOption };
  }) => {
    setCameraType(e.changes.type_);
    setIndex(e.selected[0]);
  };

  return (
    <CameraOptionsWrapper>
      <div>Camera Options</div>
      <ButtonGroup
        handlers={{ onClick }}
        data={[...buttonsConfig]}
        selected={activeButtonIndex}
      />
    </CameraOptionsWrapper>
  );
};

export default CameraOptions;
